import { computed, Injectable, signal } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductDetailsModalStateService {

  private _isOpen = signal(false);
  readonly isOpen = computed(() => this._isOpen());

  private _product = signal<Product | null>(null);
  readonly product = computed(() => this._product());

  open(product: Product) {
    this._product.set(product);
    this._isOpen.set(true);
  }

  close() {
    this._isOpen.set(false);
    this._product.set(null);
  }
}
